var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTagline',{attrs:{"elements":_vm.tagline_elem}}),_c('TutorialContestuale',{attrs:{"video_to_show":['area_assistenza']}}),_c('b-row',[_c('b-col',[_c('div',{attrs:{"id":"iframe-container"}},[_c('b-embed',{attrs:{"type":"iframe","src":_vm.faq_url}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }